module.exports = __webpack_public_path__ + "img/mendianxinxi.64ceb6bb.png";